import { authenticatedApi } from "../api";
import { MICROSERVICE_CONFIG } from "../../config/configs";

export const getAllGifts_api = async (params) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.SUPERADMIN_BFF}/gifts?${params}`
	);
	return response.data;
};

export const getAllGiftStatus_api = async (params) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.GIFT}/statuses/gift`
	);
	return response.data;
};

export const getAllPaymentStatus_api = async (params) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.GIFT}/statuses/payment`
	);
	return response.data;
};

export const getAllGiftsDetails_api = async (id) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.SUPERADMIN_BFF}/gifts/${id}`
	);
	return response.data;
};

export const downloadGifts_api = async (params) => {
	const response = await authenticatedApi.post(
		`${MICROSERVICE_CONFIG.SUPERADMIN_BFF}/download/gifts`,
		params
	);
	return response.data;
};
